<template>
  <div class="Construction">
    <!-- 当前位置 -->
    <Breadcrumb key="Breadcrumb"></Breadcrumb>
    <!-- <div class="Engineering_menu__box"> -->
    <div class="screen_content">
      <TabTitle key="TabTitle"></TabTitle>
      <!-- 筛选条件 -->
      <Screen
        @close="close"
        @change="change"
        :screenList="screenList"
        :constructionList="constructionList"
        :constructionChildrenList="constructionChildrenList"
      ></Screen>
      <!-- 选择分类 cid 1 2 3 -->
      <SelectionSort
        ref="SelectionSort"
        @change="change"
        @assignment="assignment"
        :constructionList="constructionList"
        :areaList="areaList"
        :constructionChildrenList="constructionChildrenList"
      ></SelectionSort>
    </div>
    <!-- 属性 -->
    <!-- 出租列表（文字格式） -->
    <LeaseList
      :teamList="teamList.records"
      :loadingTrue="loadingTrue"
      :noTextData="noTextData"
    ></LeaseList>
    <!-- 分页 -->
    <Pagination
      :param="param"
      @change="getTeam"
      v-if="teamList.records.length != 0"
      :loadingTrue="loadingTrue"
    ></Pagination>
    <!-- </div> -->
  </div>
</template>

<script>
import sessionStorage from "@/storage/sessionStorage"
import Breadcrumb from "@/views/Construction/components/Breadcrumb" // 当前位置
import TabTitle from "@/components/public/TabTitle" // 选择

import Screen from "@/views/Construction/components/Screen" // 筛选条件
import SelectionSort from "@/views/Construction/components/SelectionSort" // 选择分类
import LeaseList from "@/views/Construction/components/LeaseList" // 出租列表（文字格式）
import Pagination from "@/views/Construction/components/Pagination" // 分页
import { apiTeam, apiPublic } from "@/api/apiScreen.js"
// import { apiTalents, apiTeam, apiEnterprise, apiPublic } from '@/api/apiScreen.js'
export default {
  name: "Construction",
  components: {
    Breadcrumb,
    TabTitle,
    Screen,
    SelectionSort,
    LeaseList,
    Pagination
  },
  data() {
    return {
      param: {
        page: 1,
        limit: 20
      },
      searchData: {
        timeSort: 2
      },
      teamList: {
        records: []
      },
      loadingTrue: true,
      noTextData: false,
      // area_name 服务区域，title 标题，scale 队伍规模，update_time 更新时间
      constructionList: [],
      constructionChildrenList: [],
      areaList: [],
      screenList: {
        areaList: {
          name: "",
          index: null,
          item: {}
        },
        constructionList: {
          name: "",
          index: null,
          item: {}
        },
        constructionChildrenList: {
          name: "",
          index: null,
          item: {}
        }
      }
    }
  },
  mounted() {},
  // 方法
  methods: {
    async findCategoryListTree() {
      let res = await apiTeam.findCategoryListTree()
      this.constructionList = res.data.data
    },
    async getAreaSecond() {
      let res = await apiPublic.getAreaSecond()
      this.areaList = res.data.data
    },
    async getTeam() {
      this.loadingTrue = true
      let param = {
        page: this.param.page,
        limit: this.param.limit
      }
      this.reset()
      //
      let res = await apiTeam.getTeam(param, this.searchData)
      this.teamList = res.data.data
      if (this.teamList.records.length === 0) {
        this.noTextData = true
      } else {
        this.noTextData = false
      }
      this.loadingTrue = false
      this.$set(this.param, "total", res.data.data.total)
    },
    reset() {
      // 施工工队 location team_category_no 一级分类，business_scope 二级分类
      this.searchData = {
        timeSort: 2
      }
      if (this.screenList.areaList.item.no) {
        this.$set(this.searchData, "location", this.screenList.areaList.item.no)
      }
      if (this.screenList.constructionList.item.no) {
        this.$set(
          this.searchData,
          "team_category_no",
          this.screenList.constructionList.item.no
        )
      }
      if (this.screenList.constructionChildrenList.item.no) {
        this.$set(
          this.searchData,
          "second",
          this.screenList.constructionChildrenList.item.no
        )
      }
    },
    change(type, item, index) {
      this.teamList.records = []
      this.noTextData = false
      this.loadingTrue = true
      this.param.page = 1
      if (type !== "all") {
        this.screenList[type].name = item.simpleName
        //
        this.screenList[type].index = index
        this.screenList[type].item = item
      } else {
        this.screenList.areaList.name = ""
        this.screenList.areaList.item = {}
        this.screenList.constructionList.name = ""
        this.screenList.constructionList.item = {}
        this.screenList.constructionChildrenList.name = ""
        this.screenList.constructionChildrenList.item = {}
      }
      if (type === "constructionList") {
        this.screenList.constructionChildrenList.item = {}
        this.constructionChildrenList = this.constructionList[index].children
        this.assignment("constructionChildrenList", 1)
      }
      this.getTeam()
    },
    close(typeName, bol) {
      if (typeName === "constructionList") {
        this.$refs.SelectionSort.reset(typeName)
      }
      this.param.page = 1
      this.noShow(typeName)
      if (typeName === "constructionList" || bol === 1) {
        this.assignment(typeName, 1)
      } else {
        this.assignment(typeName)
      }
    },
    assignment(typeName, bol) {
      // 给三级分类 赋值
      if (typeName !== "all") {
        this.param.page = 1
        this.screenList[typeName].name = ""
        this.screenList[typeName].index = null
        this.screenList[typeName].item = {}
        if (typeName === "constructionList") {
          this.close("constructionChildrenList", 1)
        }
        if (bol !== 1) {
          this.getTeam()
        }
      } else {
        this.screenList.areaList.name = ""
        this.screenList.areaList.item = {}
        this.screenList.constructionList.name = ""
        this.screenList.constructionList.item = {}
        this.screenList.constructionChildrenList.name = ""
        this.screenList.constructionChildrenList.item = {}
      }
    },
    noShow(typeName) {
      this.$refs.SelectionSort.reset(typeName, 1)
    },
    first() {
      let query = sessionStorage.read("query")
      let item = JSON.parse(query)
      for (let i = 0; i < this.constructionList.length; i++) {
        if (this.constructionList[i].no === item.item.no) {
          this.$refs.SelectionSort.change(
            "constructionList",
            i,
            this.constructionList[i]
          )
        }
      }
    },
    second() {
      let query = sessionStorage.read("query")
      query = JSON.parse(query)
      let inner = query.item
      let item
      for (let i = 0; i < this.constructionList.length; i++) {
        if (this.constructionList[i].no === query.parentId) {
          item = this.constructionList[i]
          this.screenList["constructionList"].name = inner.name
          this.screenList["constructionList"].index = i
          this.screenList["constructionList"].item = inner
          this.constructionChildrenList = this.constructionList[i].children
          this.$refs.SelectionSort.constructionListAll = false
          this.$set(this["constructionList"][i], "show", true)
          break
        }
      }
      for (let i = 0; i < item.children.length; i++) {
        if (item.children[i].no === query.items.no) {
          let items = item.children[i]
          this.screenList["constructionChildrenList"].name = items.name
          this.screenList["constructionChildrenList"].index = i
          this.screenList["constructionChildrenList"].item = items
          this.$refs.SelectionSort.constructionChildrenListAll = false
          this.$set(this["constructionChildrenList"][i], "show", true)
        }
      }
      this.getTeam()
    }
  },
  watch: {
    constructionList() {
      this.constructionChildrenList = []
      //
      for (let i = 0; i < this.constructionList.length; i++) {
        if (this.constructionList[i].show) {
          this.constructionChildrenList = this.constructionChildrenList.concat(
            this.constructionList[i].children
          )
        }
      }
    }
  },
  async created() {
    this.getAreaSecond()
    let query = sessionStorage.read("query")
    if (query) {
      query = JSON.parse(query)
      if (query.type && query.type === "one") {
        await this.findCategoryListTree()
        this.first()
      } else if (query.type && query.type === "two") {
        await this.findCategoryListTree()
        this.second()
      } else {
        this.findCategoryListTree()
        this.getTeam()
      }
    } else {
      this.findCategoryListTree()
      this.getTeam()
    }
  },
  destroyed() {
    sessionStorage.clear("query")
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.tc-5 {
  height: 5px;
}
</style>
<style lang="scss" rel="stylesheet/scss">
.Construction {
  .el-pager li {
    background: none;
  }
  .el-pagination button:disabled {
    background: none;
  }
  .btn-next {
    background: none;
  }
  .btn-prev {
    background: none;
  }
}
</style>
